// Client "API Docs" screen — mounts the reused legacy ApiDocumentation (browse ALL
// APIs + interactive "Try it").
//
// It wraps itself in the legacy DashboardLayout, which renders children-only inside the
// Console (see console/insideConsole.js), so there's no second header/logout. Its
// environment follows the Console's Preprod/Prod toggle.
//
// Entitlement note: docs are visible for every API; only the APIs a user is enabled for
// will actually succeed when run — the backend api-key gate returns 403 otherwise.
import ApiDocumentation from "../ApiDocumentation";

export default function ConsoleDocs() {
  return <ApiDocumentation />;
}
